import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { BlogPostDateInterface } from 'common/types/entities/BlogPostDateInterface'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { ResetEntityStyles } from 'src/editor/shared/settings/reset-entity-styles-button'
import TextFontUpdater from '../components/Font/TextFontUpdater'
import { useUpdateEntity, useUpdateProp } from '../hooks/useUpdateProps'
import HtmlAttrId from '../options/HtmlAttrId'
import { AlignStyle, FontSize, LineHeight } from '../styles'

function BlogPostDateSettingsNew({
  entity,
  defaultEntity,
}: {
  entity: BlogPostDateInterface
  defaultEntity?: BlogPostDateInterface
}) {
  const updateEntity = useUpdateEntity<BlogPostDateInterface>()
  const updateProp = useUpdateProp(entity)

  const { isMobile } = useDeviceModeContext()

  return (
    <>
      <GroupTitle
        withoutHorizontalLine
        afterChildren={
          defaultEntity && (
            <ResetEntityStyles
              entity={entity}
              defaultEntity={defaultEntity}
              keys={[
                'fontFamily',
                'fontFileId',
                'alignSelf',
                'lineHeight',
                'fontStyle',
                'fontWeight',
              ]}
              mobileKeys={[
                'mobileFontFamily',
                'mobileFontFileId',
                'mobileAlignSelf',
                'mobileLineHeight',
                'mobileFontStyle',
                'mobileFontWeight',
              ]}
            />
          )
        }
      >
        typography
      </GroupTitle>
      <AlignStyle
        align={isMobile ? entity.mobileAlignSelf : entity.alignSelf}
        update={
          isMobile ? updateProp('mobileAlignSelf') : updateProp('alignSelf')
        }
        isFlex={false}
      />
      <LineHeight
        lineHeight={entity.lineHeight}
        mobileLineHeight={entity.mobileLineHeight}
        update={updateProp('lineHeight')}
        mobileUpdate={updateProp('mobileLineHeight')}
        fontSize={entity.fontSize}
        mobileFontSize={entity.mobileFontSize}
      />
      <FontSize
        labelText="entity_settings.content_table.header_font_size"
        update={updateProp('fontSize')}
        mobileUpdate={updateProp('mobileFontSize')}
        fontSize={entity.fontSize}
        mobileFontSize={entity.mobileFontSize}
      />
      <TextFontUpdater<BlogPostDateInterface>
        entity={entity}
        update={updateEntity}
      />
      <GroupTitle
        afterChildren={
          defaultEntity && (
            <ResetEntityStyles
              entity={entity}
              defaultEntity={defaultEntity}
              keys={['color']}
              mobileKeys={['mobileColor']}
            />
          )
        }
      >
        color
      </GroupTitle>
      <ColorPickerControl
        update={updateProp('color')}
        mobileUpdate={updateProp('mobileColor')}
        color={entity.color}
        mobileColor={entity.mobileColor}
      />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        defaultMargin={
          isMobile ? defaultEntity?.mobileMargin : defaultEntity?.margin
        }
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default BlogPostDateSettingsNew
